module.exports = __webpack_public_path__ + "img/step_m_en.ab99ecd1.png";